import { useEffect, useState } from 'react';

export default function useIsScreenSmallerThan(widthInPx: number): boolean {
  const getIsScreenSmallerThan = (): boolean => {
    return window.innerWidth < widthInPx;
  };

  const [isScreenSmallerThan, setIsScreenSmallerThan] = useState(
    getIsScreenSmallerThan()
  );

  const handleResize = () => {
    setIsScreenSmallerThan(getIsScreenSmallerThan());
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  });

  return isScreenSmallerThan;
}
